// API Configuration
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://f5pusrtdfl.execute-api.eu-west-1.amazonaws.com/prod';

// Mock mode - controlled by environment variable
// Set VITE_USE_MOCK_DATA=true in .env to use mock data instead of real backend
export const USE_MOCK_DATA = import.meta.env.VITE_USE_MOCK_DATA === 'true';

export const API_ENDPOINTS = {
  competitions: `${API_BASE_URL}/public/competitions`,
  standings: (competitionId) => `${API_BASE_URL}/public/competitions/${competitionId}/standings`,
  matches: (matchId) => `${API_BASE_URL}/public/matches/${matchId}`,
  teams: (teamId) => `${API_BASE_URL}/public/teams/${teamId}`,
  players: (playerId) => `${API_BASE_URL}/public/players/${playerId}`,
  captainMatches: `${API_BASE_URL}/matches`,
  pendingMatches: `${API_BASE_URL}/matches/pending`,
  logResults: `${API_BASE_URL}/matches/log-results`,
  acceptResults: `${API_BASE_URL}/matches/accept-results`,
  submitResults: (matchId) => `${API_BASE_URL}/matches/${matchId}/results`,
  approveResults: (matchId) => `${API_BASE_URL}/matches/${matchId}/approve`,
};

export default API_BASE_URL;
